import { Component } from '@angular/core';

import { NavController, LoadingController } from 'ionic-angular';

import { TabsPage } from '../tabs/tabs';
import { SignupPage } from '../signup/signup';
import { ConfirmPage } from '../confirm/confirm';
import { ForgotPwPage } from '../forgotpw/forgotpw';

import { User } from '../../providers/providers';

export class LoginDetails {
  username: string;
  password: string;
}

const url = 'https://cdn.chitika.net/getads.js';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  
  loadAPI: Promise<any>;
  public placement_id:number;
  public bannerId:string = "not set";

  public loginDetails: LoginDetails;
  public errorMessage:string = "Incorrect Email or Password!"

  constructor(public navCtrl: NavController,
              public user: User,
              public loadingCtrl: LoadingController) {
    this.loginDetails = new LoginDetails(); 
  }

  login() {
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let details = this.loginDetails;
    console.log('login..');
    this.user.login(details.username, details.password).then((result) => {
      console.log('result:', result);
      loading.dismiss();
      this.navCtrl.setRoot(TabsPage);
    }).catch((err) => { 
      if (err.message === "User is not confirmed.") {
        loading.dismiss();
        this.navCtrl.push(ConfirmPage, { 'username': details.username });
      }
      console.log('errrror', err);
      alert("Incorrect username or password");
      loading.dismiss();
    });
  }

  signup() {
    this.navCtrl.push(SignupPage);
  }

  resetPw() {
    this.navCtrl.push(ForgotPwPage);
  }

  //ngOnInit(){
    ngAfterViewInit(){
    this.loadAPI = new Promise((resolve) => {
        console.log('resolving promise...');
        this.loadScript();
    }).catch((err)=>{
      let t = err;
      console.log(t);
    });
}

public loadScript() {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    this.chitikaAddHeight();
}

chitikaAddHeight(){
  if (window['CHITIKA'] === undefined) { window['CHITIKA'] = { 'units' : [] }; };
        var unit = {"calltype":"async[2]","publisher":"picladder","width":320,"height":50,"sid":"Chitika Default"};
        this.placement_id = window['CHITIKA'].units.length;
        window['CHITIKA'].units.push(unit);
        this.bannerId = "chitikaAdBlock-"+this.placement_id.toString();
        //document.write('<div id="chitikaAdBlock-' + this.placement_id + '"></div>');
}

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts